import { createFromIconfontCN } from '@ant-design/icons'
import { Badge, Button, Dropdown, Menu, Modal } from 'antd'
import Avatar from 'components/Avatar'
import Flex from 'components/Flex'
import AlertIcon from 'components/icons/AlertIcon'
import ArrowDown from 'components/icons/ArrowDown'
import ManageIcon from 'components/icons/ManageIcon'
import NotificationIcon from 'components/icons/NotificationIcon'
import PluginLiveLogo from 'components/icons/PluginLiveLogo'
import AccountSwitcher from 'components/AccountSwitcher'
import HeaderInstituteInfo from 'modules/Page/Components/Partials/HeaderInstituteInfo'
import Notification from 'modules/Page/Components/Partials/NotificationDrawer/index'
import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'

const BREAKPOINT = '999px'

const StyledFlex = styled(Flex)`
  position: sticky !important;
  top: 0;
  z-index: 2;
  padding: 5px 48px 5px 20px;
  height: 82px;
  margin: 0px -20px;
  background: #ffffff;
  box-shadow: 0px 2px 8px rgba(201, 201, 201, 0.1),
    inset 0px -1px 0px rgba(0, 0, 0, 0.05);
  @media screen and (max-width: ${BREAKPOINT}) {
    padding: 15px 20px 15px 0px !important;
    background: #ffffff;
    margin: 0px !important;
  }
`

const IconWrapper = styled(Flex)`
  background-color: white;
  min-width: 200px;
  max-width: 200px;
  justify-content: center;
`

const Divider = styled.div`
  border-left: 1px solid #e6e7ea;
  margin-right: 25px;
  height: 55px;
`
const FlexDiv = styled(Flex)`
  gap: 20px;
`
export const ManageText = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #343e59;
`
export const DropMenu = styled(Menu)`
  width: 300px;
  padding: 10px;
`
export const ManageFlex = styled(Flex)`
  height: 35px;
  padding-top: 8px;
  gap: 8px;
`
export const AdminDiv = styled.div`
  padding: 3px 6px 4px;
  width: 44px;
  height: 17px;
  background: #dff0ea;
  border-radius: 3px;
  font-style: normal;
  font-weight: 700;
  font-size: 10px;
  line-height: 13px;
  color: #5db594;
  margin-top: 8px;
`
export const Outerdiv = styled(Flex)`
  padding: 5px;
  text-align: center;
`
export const NameDiv = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
  color: #343e59;
  padding: 8px;
`
export const EmailDiv = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 15px;
  color: #808697;
`
export const Badges = styled(Badge)`
  .ant-badge-count {
    border-radius: 14px;
    width: 23px;
    height: 16px;
    background: coral;
    color: white;
    font-weight: 600;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`
export const NotificationDiv = styled.div`
  cursor: pointer;
`
export const UserFlex = styled(Flex)`
  cursor: pointer;
`

const IconFont = createFromIconfontCN({
  scriptUrl: '//at.alicdn.com/t/font_8d5l8fzk5b87iudi.js',
})
const { confirm } = Modal

const CheckUserLogo = (logo, sizeValue, userData) => {
  if (!logo) {
    return (
      <Avatar
        background
        size={sizeValue}
        IconName={userData?.first_name[0]}
        font={18}
      />
    )
  } else {
    return <Avatar size={sizeValue} src={userData?.profile_picture} />
  }
}

const Header = ({
  corporateData,
  userData,
  userRole,
  signOut,
  getNotificationsList,
  notificationData,
  markNotificationReadApi,
  checkout,
  getSingleCandidateInterviewDetails,
  candidateInterviewDetails,
  getRoleMetrics,
  rolesMetrics,
  updateInterviewStatus,
  addCorporateBranch,
  getRescheduleList,
  notifyReschedule,
  candidateDetails,
  getCandidateDetails,
  getRoleRounds,
  roundItemList,
  setLoading,

  interViewerList,
  createInterview,
  driveId,
  roleId,
  driveInterViewerList,
  getDriveInterviewerList,
  driveData,
  getCandidateList,
  getInterViewLocation,
  getListOfCountries,
  getListOfStates,
  getListOfCities,
  listOfCountries,
  listOfStates,
  listOfCities,
  interViewData,
  corporateLocationsList,
  getCorporateLocationsList,
  groupList,
  getGroupDiscussionList,
  UpdateScheudle,
  getDriveRoleCandidatesList,
}) => {
  const [notification, setNotification] = useState(false)
  const [notificationCount, setNotificationCount] = useState(0)

  const getRoleName = id => {
    let roleName = userRole?.filter(data => data?.id === id)[0]?.name
    return roleName || 'Admin'
  }

  const onLogout = () => {
    confirm({
      title: 'Are you sure you want to Logout ?',
      okText: 'Confirm',
      okType: 'primary',
      cancelText: 'Cancel',
      onOk: async () => {
        signOut()
      },
    })
  }
  const handleCheckout = () => {
    confirm({
      title: 'Are you sure you want to Checkout ?',
      okText: 'Confirm',
      okType: 'primary',
      cancelText: 'Cancel',
      onOk: async () => {
        checkout(userData?.email)
      },
    })
  }

  const menu = (
    <DropMenu
      items={[
        {
          label: (
            <Outerdiv column centerVertically>
              {userData?.first_name
                ? CheckUserLogo(userData?.profile_picture, 64, userData)
                : null}

              <NameDiv>
                {userData?.first_name} {userData?.last_name}
              </NameDiv>
              <EmailDiv>{userData?.email}</EmailDiv>
              {userData?.admin_role_id && (
                <AdminDiv> {getRoleName(userData?.admin_role_id)}</AdminDiv>
              )}
            </Outerdiv>
          ),
          key: '0',
        },
        {
          type: 'divider',
        },
        {
          label: (
            <Link to="/manageprofile">
              <ManageFlex>
                <Avatar src={<ManageIcon />} />

                <ManageText>Manage Profile</ManageText>
              </ManageFlex>
            </Link>
          ),
          key: '1',
        },
        {
          type: 'divider',
        },
        {
          label: (
            <div style={{ maxWidth: '280px', overflow: 'hidden' }}>
              <AccountSwitcher currentJourney="corporate" />
            </div>
          ),
          key: '2',
        },
        {
          type: 'divider',
        },
        {
          label: (
            <ManageFlex onClick={onLogout}>
              <Avatar size={36} src={<AlertIcon />} />
              <ManageText>Logout</ManageText>
            </ManageFlex>
          ),
          key: '3',
        },
      ]}
    />
  )

  return (
    <>
      <StyledFlex spaceBetween centerVertically isDisplay={true}>
        <Flex centerVertically>
          <IconWrapper>
            <PluginLiveLogo />
          </IconWrapper>
          <Divider />

          <HeaderInstituteInfo corporateData={corporateData} />
        </Flex>

        <FlexDiv centerVertically>
          {userData?.pluginlive_id && (
            <Flex centerVertically>
              <Button
                type="primary"
                icon={<IconFont type="icon-tuichu" />}
                shape="round"
                onClick={() => handleCheckout()}
              >
                Checkout
              </Button>
            </Flex>
          )}
          {}
          {}
          <NotificationDiv
            onClick={() => setNotification(true)}
            title={'Notification'}
          >
            {notificationCount ? (
              <Badges count={notificationCount <= 9 ? notificationCount : '9+'}>
                <NotificationIcon />
              </Badges>
            ) : (
              <NotificationIcon />
            )}
          </NotificationDiv>

          <Dropdown
            overlayStyle={{ zIndex: '1001' }}
            overlay={menu}
            trigger={['click']}
          >
            <UserFlex>
              {userData?.first_name
                ? CheckUserLogo(userData?.profile_picture, 40, userData)
                : null}

              <Avatar
                padding={'10px 0px 0px 0px'}
                size={36}
                src={<ArrowDown />}
              />
            </UserFlex>
          </Dropdown>
        </FlexDiv>
      </StyledFlex>
      <Notification
        notification={notification}
        setNotification={setNotification}
        userData={userData}
        getNotificationsList={getNotificationsList}
        notificationData={notificationData}
        markNotificationReadApi={markNotificationReadApi}
        getSingleCandidateInterviewDetails={getSingleCandidateInterviewDetails}
        candidateInterviewDetails={candidateInterviewDetails}
        getRoleMetrics={getRoleMetrics}
        rolesMetrics={rolesMetrics}
        updateInterviewStatus={updateInterviewStatus}
        getRescheduleList={getRescheduleList}
        notifyReschedule={notifyReschedule}
        getCandidateDetails={getCandidateDetails}
        candidateDetails={candidateDetails}
        getRoleRounds={getRoleRounds}
        roundItemList={roundItemList}
        setLoading={setLoading}
        addCorporateBranch={addCorporateBranch}
        interViewerList={interViewerList}
        createInterview={createInterview}
        driveId={driveId}
        roleId={roleId}
        driveInterViewerList={driveInterViewerList}
        getDriveInterviewerList={getDriveInterviewerList}
        driveData={driveData}
        getCandidateList={getCandidateList}
        getInterViewLocation={getInterViewLocation}
        getListOfCountries={getListOfCountries}
        getListOfStates={getListOfStates}
        getListOfCities={getListOfCities}
        listOfCountries={listOfCountries}
        listOfStates={listOfStates}
        listOfCities={listOfCities}
        interViewData={interViewData}
        corporateLocationsList={corporateLocationsList}
        getCorporateLocationsList={getCorporateLocationsList}
        getGroupDiscussionList={getGroupDiscussionList}
        groupList={groupList}
        notificationCount={notificationCount}
        setNotificationCount={setNotificationCount}
        UpdateScheudle={UpdateScheudle}
        getDriveRoleCandidatesList={getDriveRoleCandidatesList}
      />
    </>
  )
}
export default Header
